import { Chip, IconButton, Menu, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import Iconify from 'src/components/Iconify';
import { identifierByConfig } from 'src/utils/fhir';
import uuidv4 from 'src/utils/uuidv4';
import { Icon } from '@iconify/react';
import { useState } from 'react';
import { OrganizationAffilitianWithResources } from './AffiliateList';
import { capitalCase } from 'change-case';
import { checkAclValidation } from 'src/careflow/ph-core/admin/permissions/util/permission.utils';
import crsAcls from 'src/careflow/ph-core/admin/permissions/util/crs/crsAcls';
import useTenantConfigData from 'src/careflow/ph-core/multi-tenant/tenant/hook/useTenantConfigData';

type Props = {
  row: OrganizationAffilitianWithResources;
  onEditRow: VoidFunction;
  onDeleteRow: VoidFunction;
  translate: Function;
  menuItems?: JSX.Element;
};

export default function AffiliateTableRow({
  row,
  onEditRow,
  onDeleteRow,
  translate,
  menuItems,
}: Props) {
  const { componentsData } = useTenantConfigData();
  const { list } = componentsData?.organization ?? {};

  const [openMenu, setOpenMenu] = useState<HTMLElement | null>(null);

  const { id, code, identifier, active, primaryOrganization, participatingOrg } = row;

  const isAllowedToDelete = checkAclValidation({
    acls: [crsAcls.ADMIN.FHIR_ORGANIZATIONS.DELETE],
  });

  const isAllowedToView = checkAclValidation({
    acls: [crsAcls.ADMIN.FHIR_ORGANIZATIONS.VIEW],
  });

  const mapIdentifiers = identifierByConfig(identifier ?? null, list); //????

  return (
    <TableRow hover>
      <TableCell>
        <Typography variant="subtitle2" noWrap>
          {participatingOrg?.name ?? ''}
        </Typography>
      </TableCell>
      <TableCell>
        {mapIdentifiers?.map((i) => (
          <Tooltip title={i?.tooltip} key={uuidv4()}>
            <Typography variant="body2" display="flex" alignItems="center">
              <Icon icon={i?.icon} style={{ ...i?.properties }} />
              {i?.value ? i?.value : null}
            </Typography>
          </Tooltip>
        ))}
      </TableCell>
      <TableCell>
        {code?.map((e, index) => (
          <Chip key={uuidv4()} label={e?.text ?? e?.coding?.[0]?.display} />
        ))}
      </TableCell>
      <TableCell>
        <Chip
          size="small"
          label={capitalCase(
            active ? translate('details.affiliate.linked') : translate('details.affiliate.unlinked')
          )}
          color={(active && 'success') || 'error'}
        />
      </TableCell>
      <TableCell align="center">
        <IconButton
          onClick={(event) => setOpenMenu(event.currentTarget)}
          sx={{
            color: '#637381',
            '&:hover': {
              backgroundColor: 'rgba(99, 115, 129, 0.08)',
            },
          }}
        >
          <Iconify icon="eva:more-vertical-fill" />
        </IconButton>

        <Menu
          anchorEl={openMenu}
          open={Boolean(openMenu)}
          onClose={() => setOpenMenu(null)}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          {menuItems}
        </Menu>
      </TableCell>
    </TableRow>
  );
}
